import forgeProperties from './properties.json';
import './modom_manager.css';
import pluginSet from './plugins';

const forgePropertiesObjects = forgeProperties.data.collection.map(
    ({objectid, name, properties}) => ({objectid, name, properties: properties.Other})
).filter(
    ({properties = {}}) => properties.Forge_Configuration
);

class ModomOptionsManager {
    _plugins = pluginSet;

    constructor() {
        this.rootConfigurationPanel = null;
        this.rootLengthPanel = null;
        this.rootTogglesPanel = null;

        this.plugins = this._plugins.map(Plugin => {
            const newPlugin = new Plugin(this);
            return newPlugin;
        });
        this.pluginPanels = {};

        this.modelData = [...forgePropertiesObjects];
        this.options = {
            // Panels settings
            editingType: '',
            editingWallCode: '',

            // Model settings
            layout: 'lineare',
            configuration: 'DPR',
            length: 4,

            front: '1',
            back: '1',

            frontLoggia: 'FR.LG',
            backLoggia: 'BK.LG',

            walls: {
                // Right
                R1: '1',
                R2: '1',
                R3: '1',
                R4: '1',
                R5: '1',
                R6: '1',
                R7: '1',

                // Left
                L1: '1',
                L2: '1',
                L3: '1',
                L4: '1',
                L5: '1',
                L6: '1',
                L7: '1'
            }
        };
    }

    updateOptions(data = {}) {
        this.options = {
            ...this.options,
            ...data,
            walls: {
                ...this.options.walls,
                ...data.walls || {}
            }
        };
        this.filterModelWithOptions();
        this.renderTemplate();
    }

    getFilteredModelData() {
        let filteredData = this.modelData;
        for (const plugin of this.plugins) {
            filteredData = plugin.filterModelData(
                filteredData, this.options
            );
        }
        return filteredData;
    }

    getIdsForList(modelData) {
        return modelData.map(({objectid}) => objectid);
    }

    filterModelWithOptions() {
        if (this.viewer) {
            const dataToIsolate = this.getIdsForList(this.getFilteredModelData());
            this.viewer.showAll();
            this.viewer.isolate(dataToIsolate);
        }
    }

    createPanelUI(viewer, container) {
        return this.plugins.map(plugin => {
            const otherPluginNames = this.plugins
                .map(pl => pl.name)
                .filter(name => plugin.name !== name);
            return plugin.createPanelUI(viewer, container, otherPluginNames);
        });
    }

    renderTemplate() {
        for (const plugin of this.plugins) {
            plugin.renderTemplate();
        }
    }
}

export const modomOptionsManager = new ModomOptionsManager();
